export const infertilityProducts = {
  'prd-c-kup-bonraybio': {
    key: 'ckup',
    primaryMedia: '/media/source/images/c-kup-2.png',
  },
  'prd-ca0ca1-bonraybio': {
    key: 'ca0ca1',
    primaryMedia: '/media/source/images/CA0CA1-1.png',
  },
  'prd-r10-bonraybio': {
    key: 'r10',
    primaryMedia: '/media/source/images/R10-1.png',
  },
  'prd-r11-plus-bonraybio': {
    key: 'r11',
    primaryMedia: '/media/source/images/R11-1.png',
  },
  'prd-x3-pro-semen-quality-analyzer': {
    key: 'x3',
    primaryMedia: '/media/source/images/X3-1.png',
  },
} as const

export type InfertilityProductId = keyof typeof infertilityProducts
export type InfertilityProductKey = (typeof infertilityProducts)[InfertilityProductId]['key']

export function isInfertilityProductId(id: string): id is InfertilityProductId {
  return id in infertilityProducts
}
